export function display_tabs() {
  if (!document.querySelector(".prev") || !document.querySelector(".next")) {
    return false;
  }

  let currentTab = 0;

  function showTab(index) {
    const tabs = document.querySelectorAll(".tab-title");
    const contents = document.querySelectorAll(".tab-content");
    tabs.forEach((tab, i) => {
      tab.classList.toggle("active", i === index);
      contents[i].classList.toggle("active", i === index);
    });
    currentTab = index;
  }

  function showPrevTab() {
    const tabs = document.querySelectorAll(".tab-title");
    currentTab = currentTab > 0 ? currentTab - 1 : tabs.length - 1;
    showTab(currentTab);
  }

  function showNextTab() {
    const tabs = document.querySelectorAll(".tab-title");
    currentTab = currentTab < tabs.length - 1 ? currentTab + 1 : 0;
    showTab(currentTab);
  }

  // Event listeners
  document.querySelectorAll(".tab-title").forEach((tab, index) => {
    tab.addEventListener("click", () => showTab(index));
  });

  document.querySelector(".prev").addEventListener("click", showPrevTab);
  document.querySelector(".next").addEventListener("click", showNextTab);
  document.querySelector(".prevmobile").addEventListener("click", showPrevTab);
  document.querySelector(".nextmobile").addEventListener("click", showNextTab);

  // Initial display
  showTab(currentTab);

  return {
    showTab,
    showPrevTab,
    showNextTab,
  };
}
